import { stringify } from "query-string"
import { apiInstance } from "./api"

const endpoint = "/stock-transfer"

export const getStockTransferRequest = async (stockTransferId) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.get(`${endpoint}/${stockTransferId}`)

  return response.data
}

export const getStockTransferRequests = async (queries) => {
  const { dhFoods } = apiInstance()

  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await dhFoods.get(`${endpoint}?${query}`)

  return response.data
}

export const createStockTransferRequest = async (data) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.post(`${endpoint}`, data)

  return response.data
}

export const editStockTransferRequest = async (stockTransferId, data) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.patch(`${endpoint}/${stockTransferId}`, data)

  return response.data
}

export const approveStockTransferRequest = async (stockTransferId, data) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.patch(`${endpoint}/approve/${stockTransferId}`, data)

  return response.data
}

export const rejectStockTransferRequest = async (stockTransferId, data) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.patch(`${endpoint}/reject/${stockTransferId}`, data)

  return response.data
}

export const deliverStockTransferRequest = async (stockTransferId) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.patch(`${endpoint}/deliver/${stockTransferId}`)

  return response.data
}

export const receivedStockTransferRequest = async (stockTransferId, data) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.patch(`${endpoint}/received/${stockTransferId}`, data)

  return response.data
}

export const cancelStockTransferRequest = async (stockTransferId) => {
  const { dhFoods } = apiInstance()


  const response = await dhFoods.patch(`${endpoint}/cancel/${stockTransferId}`)

  return response.data
}

export const setStockTransferRequestAsViewed = async (stockTransferId) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.patch(`${endpoint}/viewed/${stockTransferId}`)

  return response.data
}

export const editApprovedStockTransferRequest = async (stockTransferId, data) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.patch(`${endpoint}/edit/approve/${stockTransferId}`, data)

  return response.data
}


export const getNotViewedStockTransferRequestsCount = async (queries) => {
  const { dhFoods } = apiInstance()

  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await dhFoods.get(`${endpoint}/count/notViewed?${query}`)

  return response.data
}

export const resolveStockTransferRequestDiscrepancy = async (stockTransferId, data) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.patch(`${endpoint}/resolve/${stockTransferId}`, data)

  return response.data
}